import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import { DASHBOARD_PATH } from 'config';
import { useSelector } from 'react-redux';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }) => {
    const { token } = useSelector((state) => state.user);

    const navigate = useNavigate();

    window.addEventListener('error', e => {
        // prompt user to confirm refresh
        if (/Loading chunk [\d]+ failed/.test(e.message)) {
          window.location.reload();
        }
      });
      
    useEffect(() => {
        if (token) {
            navigate(DASHBOARD_PATH, { replace: true });
        }
        // eslint-disable-next-line
    }, [token]);

    return children;
};

GuestGuard.propTypes = {
    children: PropTypes.node
};

export default GuestGuard;
